import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {doLogin} from './firebase/firebase';
import * as routes from './routes';

import { Layout, Form, Icon, Input, Button } from 'antd';
const {Content} = Layout;
const FormItem = Form.Item;

const Login = ({ history }) =>
  <Layout>
    <Content>
      <div className='flex-center' style={{height: '100vh'}}>
        <div className="logo" style={{width: '240px', height: '80px', backgroundSize: 'contain'}}/>
        <LoginForm history={history} />
      </div>
    </Content>
  </Layout>

  const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
  });
  const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
    loading: false
  };

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  onSubmit = (event) => {
    this.setState({ loading: true });
    event.preventDefault();
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    doLogin(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.DASH);

      })
      .catch(error => {
        this.setState({ loading: false });
      });

  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';
    return(
      <Form autoComplete='off' onSubmit={this.onSubmit} className="login-form" style={{width: '280px'}} >
        <input type="text" style={{display:'none'}} />
        <input type="password" style={{display:'none'}} />
        <FormItem>
          <Input value={email}
          autoComplete='off'
          onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
          type="text"
          prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="Nom d'utilisateur" />
        </FormItem>
        <FormItem>
          <Input value={password}
          onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
          type="password"
          autoComplete='off'
          prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="Mot de Passe" />
        </FormItem>
        <FormItem>
          <Button disabled={isInvalid} loading={this.state.loading} type="primary" htmlType="submit" className="login-form-button">
           Connexion
         </Button>
        </FormItem>
        { error && <p style={{textAlign:'center', position:'absolute', maxWidth: '280px'}}>{error}</p> }
      </Form>
    );
  }
}

export default withRouter(Login);
export {
  LoginForm
};



// WEBPACK FOOTER //
// ./src/login.js